import React from "react"
import Grid from "@material-ui/core/Grid"
import Button, { ButtonProps } from "@material-ui/core/Button"
import makeStyles from "@material-ui/core/styles/makeStyles"
import CircularProgress from "@material-ui/core/CircularProgress"

interface IButtonWithProgressProps extends ButtonProps {
    loading: boolean
    buttonText: string
    wrapperClassName?: string
    buttonClassName?: string
    className?: string
    disabled?: boolean
}

const useStyles = makeStyles({
    buttonWrapper: {
        position: "relative",
    },
    button: {
        height: "46px",
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
})

export default function ButtonWithProgress(props: IButtonWithProgressProps) {
    const {
        loading,
        buttonText,
        wrapperClassName = "",
        buttonClassName = "",
        className,
        disabled,
        ...rest
    } = props
    const classes = useStyles()
    return (
        <Grid
            className={`${classes.buttonWrapper} ${className} ${wrapperClassName}`}
            container
        >
            <Button
                {...rest}
                fullWidth
                data-testid="button"
                color="primary"
                variant="contained"
                disabled={disabled ? disabled : loading}
                className={`${classes.button} ${buttonClassName}`}
            >
                {buttonText}
            </Button>
            {loading && (
                <CircularProgress
                    data-testid="progress"
                    size={24}
                    className={classes.buttonProgress}
                />
            )}
        </Grid>
    )
}
